const common = require("lib/labels/_common");

// Home.platform.services

module.exports = {
  licenceList: {
    title: {
      en: "Licences",
      fr: "Licences"
    },
    title_delete_check: common.title_delete_check,
    content_delete_check: common.content_delete_check,
    no: common.no,
    yes: common.yes,
    edit: common.edit,
    remove: {
      en: "Remove",
      fr: "Supprimer"
    },
    detailed: {
      api: {
        en: "API",
        fr: "API"
      },
      expiration: {
        en: "Expiration",
        fr: "Expiration"
      },
      maxProjects: {
        en: "Projects maximum",
        fr: "Maximum de projets"
      },
      appName: {
        en: "App",
        fr: "App"
      },
      databaseName: {
        en: "Database",
        fr: "Base de donnée"
      },
      appVersion: {
        en: "App's version",
        fr: "Version de l'application"
      },
      service: {
        en: "Database",
        fr: "Base de donnée"
      },
      groupName: {
        en: "Group",
        fr: "Groupe"
      },
    }
  },
  licenceForm: {
    stepTitle: {
      en: "Licence",
      fr: "Licence"
    },
    title: {
      creation: {
        en: "New licence",
        fr: "Nouvelle licence"
      },
      edition: {
        en: "Edit licence",
        fr: "Edition de licence"
      }
    },
    name: common.name,
    group: {
      en: "Group",
      fr: "Groupe"
    },
    api: {
      en: "API",
      fr: "API"
    },
    expiration: {
      en: "Expiration",
      fr: "Expiration"
    },
    maxProjects: {
      en: "Projects maximum",
      fr: "Maximum de projets"
    },
    testName: {
      en: "This name already exists",
      fr: "Nom déjà utilisé"
    },
    testKey: {
      en: "Characters not allowed",
      fr: "Caractère(s) non autorisé(s)"
    },
    keyAlreadyExisting: {
      en: "This key already exists",
      fr: "Clé déjà utilisé"
    }
  }
};
